import { Link } from "react-router-dom";
import { LogoMark } from "@/components/Logo";
import { CONTACT_EMAIL, CONTACT_PHONE } from "@/lib/data";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-surface/40">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <LogoMark size={30} />
              <span className="font-display text-sm font-bold tracking-[0.18em] text-slate-100">
                GLOBAL DIMENSIONS, INC.
              </span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-400">
              As-built surveys and Matterport 3D scans for retail spaces — measured in
              person, wherever your next store is.
            </p>
          </div>
          <div className="md:col-span-2">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-cad/80">Pages</p>
            <ul className="mt-5 space-y-3 text-sm">
              <li><Link data-testid="footer-link-services" to="/services" className="text-slate-400 transition-colors hover:text-cad">Services</Link></li>
              <li><Link data-testid="footer-link-process" to="/process" className="text-slate-400 transition-colors hover:text-cad">Process</Link></li>
              <li><Link data-testid="footer-link-about" to="/about" className="text-slate-400 transition-colors hover:text-cad">About</Link></li>
              <li><Link data-testid="footer-link-quote" to="/quote" className="text-slate-400 transition-colors hover:text-cad">Request a Quote</Link></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-cad/80">Services</p>
            <ul className="mt-5 space-y-3 text-sm text-slate-400">
              <li>As-Built Surveys</li>
              <li>Matterport 3D Scans</li>
              <li>Survey + Scan</li>
              <li>Real Estate &amp; Property Walkthroughs</li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-cad/80">Contact</p>
            <ul className="mt-5 space-y-3 text-sm">
              <li>
                <a
                  data-testid="footer-email-link"
                  href={`mailto:${CONTACT_EMAIL}`}
                  className="text-slate-300 transition-colors hover:text-cad"
                >
                  {CONTACT_EMAIL}
                </a>
              </li>
              <li className="text-slate-400">{CONTACT_PHONE}</li>
              <li className="text-slate-400">All 50 states · Puerto Rico · Guam</li>
            </ul>
          </div>
        </div>
        <div className="mt-14 border-t border-white/5 pt-8">
          <p className="font-mono text-[10px] uppercase leading-relaxed tracking-[0.2em] text-slate-400">
            As-built survey · Retail site survey · Existing conditions survey · Field measuring · Matterport scanning · Retail store survey · Nationwide
          </p>
          <p className="mt-4 text-xs text-slate-400">
            © 2026 Global Dimensions, Inc. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
